// Import `configureStore` from Redux Toolkit
import { configureStore } from '@reduxjs/toolkit';

// Import your root reducer or slice reducers
import reducers from '../reducers';

// Create the store with RTK's `configureStore`
const constfigureAppStore = () => {
  const store = configureStore({
    reducer: reducers,
    devTools: process.env.NODE_ENV === 'development',
  });

  return store;
};

export default constfigureAppStore;
